<!--  For some reason the not found component will not pull correctly for this.  Temporary work around.  -->
@if (+auth.token.payload.PermissionLevel < 7) {
  We're sorry -- the page you're trying to visit either could not be found or is not available to you at this time. Please use the home icon to return to MyKE.
}

@if (+auth.token.payload.PermissionLevel == 7) {
  <div class="container-fluid mx-0 mt-2">
    <h3>Test area for new editable fields</h3>
    <div class="container-fluid mt-4 pb-0">
      <div class="row">
        <div class="col">
          <text-input class="editable-override"
            [(obj)]="formObject" prop="allLabelCols" label="Base Label Width" [labelCols]="4" placeholder="Type here"
          [mode]="inputMode.Number" helpText="Required.  Labels can be set to a number from 0-12. 0 hides the label, 12 places the label and the input on separate lines."></text-input>
          @if (!!formObject.useOptionalSizes) {
            <text-input class="editable-override"
              [(obj)]="formObject" prop="allLabelColsSm" label="Sm Label Width" [labelCols]="4" placeholder="Type here"
              [mode]="inputMode.Number"
            helpText="Optional, inherits from Base Label Width if not set."></text-input>
            <text-input class="editable-override"
              [(obj)]="formObject" prop="allLabelColsMd" label="Md Label Width" [labelCols]="4" placeholder="Type here"
              [mode]="inputMode.Number"
            helpText="Optional, inherits from Sm Label Width if not set."></text-input>
            <text-input class="editable-override"
              [(obj)]="formObject" prop="allLabelColsLg" label="Lg Label Width" [labelCols]="4" placeholder="Type here"
              [mode]="inputMode.Number"
            helpText="Optional, inherits from Md Label Width if not set."></text-input>
            <text-input class="editable-override"
              [(obj)]="formObject" prop="allLabelColsXl" label="Xl Label Width" [labelCols]="4" placeholder="Type here"
              [mode]="inputMode.Number"
            helpText="Optional, inherits from Lg Label Width if not set."></text-input>
            <text-input class="editable-override"
              [(obj)]="formObject" prop="allLabelColsXxl" label="Xxl Label Width" [labelCols]="4" placeholder="Type here"
              [mode]="inputMode.Number"
            helpText="Optional, inherits from Xl Label Width if not set."></text-input>
          }
        </div>
        <div class="col">
          <boolean-slider class="editable-override"
            [(obj)]="formObject" prop="useOptionalSizes" label="Use Optional Label Sizing"
            [labelCols]="6"
            trueLabel="Yes" falseLabel="No"
          helpText="If optional sizes aren't set then label cols inherit from the Base Label Width at all breakpoints."></boolean-slider>
          <boolean-slider class="editable-override"
            [(obj)]="formObject" prop="allIsEditable" label="Editable"
            [labelCols]="6"
          trueLabel="Yes" falseLabel="No"></boolean-slider>
        </div>
      </div>
    </div>
    <div class="card p-0">
        <div class="card-body">
            <array-builder class="editable-override"
                           [labelCols]="formObject.allLabelCols"
                           [labelColsSm]="formObject.allLabelColsSm"
                           [labelColsMd]="formObject.allLabelColsMd"
                           [labelColsLg]="formObject.allLabelColsLg"
                           [labelColsXl]="formObject.allLabelColsXl"
                           [labelColsXxl]="formObject.allLabelColsXxl"
                           [(obj)]="formObject" prop="arrayBuilder"
                           label="Array Builder (free text)"
                           [arrayItemWidth]="200"
                           helptext="This input can accept any text you enter and has a set width for the items displayed."></array-builder>
            <array-builder class="editable-override"
                           [labelCols]="formObject.allLabelCols"
                           [labelColsSm]="formObject.allLabelColsSm"
                           [labelColsMd]="formObject.allLabelColsMd"
                           [labelColsLg]="formObject.allLabelColsLg"
                           [labelColsXl]="formObject.allLabelColsXl"
                           [labelColsXxl]="formObject.allLabelColsXxl"
                           [(obj)]="formObject" prop="arrayBuilder2"
                           label="Array Builder (list)"
                           [typeaheadList$]="objectTypeAheadList$ | typeaheadBinder : this"
                           [focusOpenTypeahead]="true"
                           [requireTypeaheadSelection]="true"
                           (optionSelectEmitter$)="emitter($event)"
                           helptext="This input can only accept items that are selected from the typeahead list."></array-builder>
            <boolean-slider class="editable-override"
                            [labelCols]="formObject.allLabelCols"
                            [labelColsSm]="formObject.allLabelColsSm"
                            [labelColsMd]="formObject.allLabelColsMd"
                            [labelColsLg]="formObject.allLabelColsLg"
                            [labelColsXl]="formObject.allLabelColsXl"
                            [labelColsXxl]="formObject.allLabelColsXxl"
                            [(obj)]="formObject" prop="booleanSlider" label="Bool Slider"
                            trueLabel="Yes" falseLabel="No"></boolean-slider>
            <boolean-slider class="editable-override"
                            [labelCols]="formObject.allLabelCols"
                            [labelColsSm]="formObject.allLabelColsSm"
                            [labelColsMd]="formObject.allLabelColsMd"
                            [labelColsLg]="formObject.allLabelColsLg"
                            [labelColsXl]="formObject.allLabelColsXl"
                            [labelColsXxl]="formObject.allLabelColsXxl"
                            [(obj)]="formObject" prop="booleanSlider" label="Bool Slider (small)"
                            size="sm"
                            trueLabel="Yes" falseLabel="No"></boolean-slider>
            <radio-list class="editable-override"
                        [(obj)]="formObject" prop="radio" [listOfOptions$]='radioOptionList$' [layout]="layoutMode.Horizontal"
                        label="Radio Horizontal"
                        id="radioH"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"></radio-list>
            <radio-list class="editable-override"
                        [(obj)]="formObject" prop="radio" [listOfOptions$]='radioOptionList$' [layout]="layoutMode.Vertical"
                        label="Radio Vertical"
                        id="radioV"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"></radio-list>
            <date-time class="editable-override"
                       [(obj)]="formObject" prop="date"
                       label="Date" [labelCols]="formObject.allLabelCols"
                       [labelColsSm]="formObject.allLabelColsSm"
                       [labelColsMd]="formObject.allLabelColsMd"
                       [labelColsLg]="formObject.allLabelColsLg"
                       [labelColsXl]="formObject.allLabelColsXl"
                       [labelColsXxl]="formObject.allLabelColsXxl"
                       min="{{now.getFullYear() - 1}}-03-15T00:00:00"
                       max="{{(now.getFullYear() + 1)}}-08-18T00:00:00"
                       [allowEmpty]="true"
                       placeholder="MMM DD, YYYY"
                       isBlankReadOnlyText="This only shows when value is empty"></date-time>

            <date-time class="editable-override"
                       [(obj)]="formObject" prop="dateTime"
                       label="Date/Time" [labelCols]="formObject.allLabelCols"
                       [labelColsSm]="formObject.allLabelColsSm"
                       [labelColsMd]="formObject.allLabelColsMd"
                       [labelColsLg]="formObject.allLabelColsLg"
                       [labelColsXl]="formObject.allLabelColsXl"
                       [labelColsXxl]="formObject.allLabelColsXxl"
                       min="{{now.getFullYear() - 1}}-03-15T00:00:00"
                       max="{{(now.getFullYear() + 1)}}-08-18T00:00:00"
                       [allowEmpty]="true"
                       [allowTime]="true"
                       placeholder="MMM DD, YYYY"></date-time>

            <date-time class="editable-override"
                       [(obj)]="formObject" prop="time"
                       label="Time" [labelCols]="formObject.allLabelCols"
                       [labelColsSm]="formObject.allLabelColsSm"
                       [labelColsMd]="formObject.allLabelColsMd"
                       [labelColsLg]="formObject.allLabelColsLg"
                       [labelColsXl]="formObject.allLabelColsXl"
                       [labelColsXxl]="formObject.allLabelColsXxl"
                       [allowDate]="false"
                       [allowTime]="true"
                       placeholder="Select a time"></date-time>

            <date-time class="editable-override"
                       [(obj)]="formObject" prop="monthYear"
                       min="{{now.getFullYear() - 1}}-03-01T00:00:00"
                       max="{{(now.getFullYear() + 1)}}-08-31T00:00:00"
                       label="Date (Month/Year)" [labelCols]="formObject.allLabelCols"
                       [labelColsSm]="formObject.allLabelColsSm"
                       [labelColsMd]="formObject.allLabelColsMd"
                       [labelColsLg]="formObject.allLabelColsLg"
                       [labelColsXl]="formObject.allLabelColsXl"
                       [labelColsXxl]="formObject.allLabelColsXxl"
                       [allowEmpty]="true"
                       [dayOverride]="31"
                       placeholder="MMM YYYY"></date-time>

            <dropdown class="editable-override"
                      [(obj)]="formObject" prop="dropdown" label="Dropdown"
                      [labelCols]="formObject.allLabelCols"
                      [labelColsSm]="formObject.allLabelColsSm"
                      [labelColsMd]="formObject.allLabelColsMd"
                      [labelColsLg]="formObject.allLabelColsLg"
                      [labelColsXl]="formObject.allLabelColsXl"
                      [labelColsXxl]="formObject.allLabelColsXxl"
                      [listOfOptions$]="dropdownList$" [invalidValueMode]="invalidValueMode.AllowEnabled"
                      [optionsToShow]="1" [maxSelectionCount]="1"
                      placeholder="Select one"></dropdown>
            <dropdown class="editable-override"
                      [(obj)]="formObject" prop="dropdownMulti" label="Dropdown Multi Select"
                      [labelCols]="formObject.allLabelCols"
                      [labelColsSm]="formObject.allLabelColsSm"
                      [labelColsMd]="formObject.allLabelColsMd"
                      [labelColsLg]="formObject.allLabelColsLg"
                      [labelColsXl]="formObject.allLabelColsXl"
                      [labelColsXxl]="formObject.allLabelColsXxl"
                      [listOfOptions$]="dropdownList$" [invalidValueMode]="invalidValueMode.AllowEnabled"
                      [optionsToShow]="6" [maxSelectionCount]="2"
                      helpText="Can select up to 2 options."></dropdown>
            <file-upload [(obj)]="formObject"
                         prop="fileUpload"
                         label="File Upload"
                         [labelCols]="formObject.allLabelCols"
                         [labelColsSm]="formObject.allLabelColsSm"
                         [labelColsMd]="formObject.allLabelColsMd"
                         [labelColsLg]="formObject.allLabelColsLg"
                         [labelColsXl]="formObject.allLabelColsXl"
                         [labelColsXxl]="formObject.allLabelColsXxl"
                         accept="{{testService.acceptedFileTypes.toString()}}"
                         helpText="You won't be able to test actually uploading, but you can test selection and validation."></file-upload>
            <text-input class="editable-override" [(obj)]="formObject" prop="textInput" label="Text Input"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"></text-input>
            <!--  RICH TEXT  -->
            <rich-text-input class="editable-override" [(obj)]="formObject" prop="richTextInput"
                             label="Rich Text Input"
                             [labelCols]="formObject.allLabelCols"
                             [labelColsSm]="formObject.allLabelColsSm"
                             [labelColsMd]="formObject.allLabelColsMd"
                             [labelColsLg]="formObject.allLabelColsLg"
                             [labelColsXl]="formObject.allLabelColsXl"
                             [labelColsXxl]="formObject.allLabelColsXxl"
                             [maxLength]="40"
                             [defaultHeight]="150"
                             placeholder="Type here"
                             helpText="The character limit is placed on the HTML characters, not the visible typed ones."></rich-text-input>
            <!-- FLAVORS OF TEXT INPUTS  -->
            <text-input class="editable-override" [(obj)]="formObject" prop="textInputDollarsCents"
                        label="Text Input Dollars/Cents"
                        [mode]="inputMode.Text" [displayFormat]="formatter.DollarsAndCents"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"></text-input>
            <text-input class="editable-override" [(obj)]="formObject" prop="textInputDollarsOnly"
                        label="Text Input Dollars Only"
                        [mode]="inputMode.Text" [displayFormat]="formatter.DollarsOnly"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"></text-input>
            <text-input class="editable-override" [(obj)]="formObject" prop="textInputCostCode"
                        label="Text Input Cost Code"
                        [mode]="inputMode.Text" [displayFormat]="formatter.CostCode"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"></text-input>
            <!-- Typeahead using an API call that returns objects -->
            <text-input class="editable-override"
                        [(obj)]="formObject" prop="textInputTypeahead" label="Text Input Typeahead (Try 'ale')"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"
                        [typeaheadList$]="peopleService.personTypeaheadList$ | typeaheadBinder : peopleService"></text-input>
            <!--Typeahead using a simple list-->
            <text-input class="editable-override"
                        [(obj)]="formObject" prop="textInputTypeahead2" label="Text Input Typeahead 2 (Try 'berr')"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"
                        [typeaheadList$]="simpleTypeAheadList$ | typeaheadBinder : this"
                        (optionSelectEmitter$)="emitter($event)"></text-input>
            <!-- Typeahead using a simple list that can open the dropdown on click-->
            <text-input class="editable-override"
                        [(obj)]="formObject" prop="textInputTypeahead3" label="Text Input Typeahead 3 (Try 'berr' or click to see full list)"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"
                        [typeaheadList$]="simpleTypeAheadList$ | typeaheadBinder : this"
                        [focusOpenTypeahead]="true"
                        (optionSelectEmitter$)="emitter($event)"></text-input>
            <text-input class="editable-override"
                        [(obj)]="formObject" prop="textAreaInput" label="Text Area Input"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"
                        [mode]="inputMode.TextArea" [maxLength]="25"></text-input>
            <text-input class="editable-override"
                        [(obj)]="formObject" [prop]="'numberInput'" label="Number Input"
                        [labelCols]="formObject.allLabelCols"
                        [labelColsSm]="formObject.allLabelColsSm"
                        [labelColsMd]="formObject.allLabelColsMd"
                        [labelColsLg]="formObject.allLabelColsLg"
                        [labelColsXl]="formObject.allLabelColsXl"
                        [labelColsXxl]="formObject.allLabelColsXxl"
                        placeholder="Type here"
                        [mode]="inputMode.Number"></text-input>
            <pre>{{ formObject | json }}</pre>
        </div>
    </div>
  </div>
}
